import React from 'react'

export const NotFound = () => <h1>Esta pagina no existe! :(</h1>
